import { render, staticRenderFns } from "./view-section-field.vue?vue&type=template&id=63e1cf6a&scoped=true&"
import script from "./view-section-field.vue?vue&type=script&lang=js&"
export * from "./view-section-field.vue?vue&type=script&lang=js&"
import style0 from "./view-section-field.vue?vue&type=style&index=0&id=63e1cf6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e1cf6a",
  null
  
)

export default component.exports